import React, { createContext, useContext } from 'react';
import { useStickyAccordionManager } from 'hooks/useStickyAccordionManager';

interface StickyAccordionContextType {
  registerAccordion: (
    id: string,
    isExpanded: boolean,
    ref: React.RefObject<HTMLDivElement>,
  ) => void;
  unregisterAccordion: (id: string) => void;
  activeStickyId: string | null;
}

const StickyAccordionContext = createContext<StickyAccordionContextType | null>(
  null,
);

export function StickyAccordionProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const manager = useStickyAccordionManager();
  return (
    <StickyAccordionContext.Provider value={manager}>
      {children}
    </StickyAccordionContext.Provider>
  );
}

export const useStickyAccordionContext = () => {
  const context = useContext(StickyAccordionContext);
  if (!context) {
    throw new Error(
      'useStickyAccordionContext must be used within StickyAccordionProvider',
    );
  }
  return context;
};
